function eyemask() {
    $.getJSON('/cart.js', function(cart) {
      if(cart.item_count == 1){
        $('cart-drawer.drawer').addClass('only_one');
      }
      else{
        $('cart-drawer.drawer').removeClass('only_one'); 
      }
       if(cart.item_count > 0){
        // const silkProducts = ['silk-pillowcase', 'silk-fitted-sheets', 'silk-quilt-covers', 'silk-flat-sheets'];
        // const hasSilkPillowcase = cart.items.some(item => silkProducts.includes(item.handle));
        // const hasSilkBeddingSet = cart.items.some(item => item.handle === 'silk-bedding-sets');
        // if (hasSilkPillowcase) {
        const hasSilkEyeMasks = cart.items.some(item => item.handle === 'silk-eye-masks');
        if(hasSilkEyeMasks){
              $('.eye-mask-only').hide();
        }
        else{
           $('.eye-mask-only').show();
        }
        // } else {
        //     console.log('No silk pillowcases found in your cart');
        //     $('.eye-mask-only').hide();
        // }
        // if (hasSilkBeddingSet) {
        //     const hasSilkPillowcase2 = cart.items.some(item => item.handle === 'silk-pillowcase');
        //     const hasSilkQuiltCovers = cart.items.some(item => item.handle === 'silk-quilt-covers');
        //     if(hasSilkPillowcase2 || hasSilkQuiltCovers){
        //       $('.both-product-item2 ,.both-product-item3').hide();
        //     }
        //     else{
        //   $('.over_hight').show();
        //     $('.both-product-item2 ,.both-product-item3').show();
        //     }
        // } else {
        //     console.log('No silk bedding sets found in your cart');
        //     $('.both-product-item2, .both-product-item3').hide();
        // }
        setTimeout(function() {
        document.querySelectorAll('.color-swatch-new').forEach(function(el) {
            const src = el.dataset.imgsrc.replace(/["\[\]]/g, '');
            el.style.backgroundSize = 'cover';
            el.style.backgroundImage = `url(${src})`;
        });
        }, 500);
       }
      else{
      $('.eye-mask-only').hide();
      }
    });
}


$(document).ready(function(){
eyemask();
})

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      console.log('on submit')
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
        setTimeout(function() {
        eyemask();
        }, 1500);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        alert(errorMessage)
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


$(document).ready(function(){
eyemask();
})
